import { TableRow } from '@material-ui/core';
import { useStyles } from '@webapps/styles';

const TableRowSeparator = () => {
  const { css } = useStyles();
  return <TableRow className={css({ height: 10 })} />;
};

export default TableRowSeparator;
